<template>
  <div class="report-filter-autosuggest form-control p-0">
    <vue-autosuggest
      ref="autosuggest"
      @focus=""
      :suggestions="suggestions"
      :on-selected="setNewValue"
      :input-props="{id:'autosuggest__input', onInputChange: onInputChange, placeholder: (placeholder ? placeholder : 'Select value')}"
    />
  </div>
</template>

<style>
.report-filter-autosuggest .autosuggest__input-open {
  border-bottom-left-radius: 0em !important;;
  border-bottom-right-radius: 0em !important;
}
#autosuggest, #autosuggest>input {
  width: 100% !important;
  border: 0;
  padding: 5px 10px;
}
.report-filter-autosuggest .autosuggest__results-container {
  position:relative;
  width: 100% !important;
}
.report-filter-autosuggest .autosuggest__results {
  margin: 0;
  position: absolute;
  z-index: 10000001;
  width: 100%;
  border: 2px solid var(--border);
  background: white;
  padding: 0px;
  overflow-y: scroll;
  max-height: 200px;
}
.report-filter-autosuggest .autosuggest__results ul {
  list-style: none;
  padding-left: 0;
  margin: 0;
}
.report-filter-autosuggest .autosuggest__results .autosuggest__results_item {
  cursor: pointer;
  padding: 0.5em;
}
.report-filter-autosuggest .autosuggest__results .autosuggest__results_item:active,
.report-filter-autosuggest .autosuggest__results .autosuggest__results_item:hover,
.report-filter-autosuggest .autosuggest__results .autosuggest__results_item:focus,
.report-filter-autosuggest .autosuggest__results .autosuggest__results_item.autosuggest__results_item-highlighted {
  background-color: var(--light);
}
</style>

<script>
import { VueAutosuggest } from 'vue-autosuggest';
import { ReportsApi } from '@/reports/api'
import moment from 'moment'
import Promise from 'bluebird'

Promise.config({
  cancellation: true
})


export default {
  props: {
    value: { required: true, type: String },
    field: { required: true, type: String },
    filters: { required: false, type: Array, default: function(){ return [] } },
    placeholder: { required: false, type: String, default: null },
    startTime: { required: false, type: Number },
    endTime: { required: false, type: Number }
  },
  created() {
  },
  data () {
    return {
      text: '',
      latestReport: [],
      reportFor: '',
      gettingReportFor: '',
      reportPromise: null,
      numReports: 0,
      getReportTimeout: null
    }
  },
  watch: {
    field: function() {
      this.latestReport = []
      this.reportFor = ''
    },
    value: function() {
      this.$refs.autosuggest.searchInput = this.value
    }
  },
  computed: {
    suggestions() {
      if(this.field.length === 0) {
        return [{data:['Select a field first']}]
      } else if(this.text.length < 3) {
        return [{data:['Input more text for suggestions...']}]
      } else if(!this.currentReportValid) {
        return [{data:['Fetching suggestions...']}]
      } else {
        let list = this.suggestList.filter(fieldName => fieldName.toUpperCase().includes(this.text.toUpperCase()))
        if(list.length === 0) {
          return [{data:['No data contains this value']}]
        }
        return [{data: list}]
      }
    },
    suggestList() {
      let list = []
      for (let row of this.latestReport) {
        if(row[this.field] !== undefined) {
          list.push(row[this.field])
        }
      }
      return list
    },
    //only valid for 3 or more characters
    currentReportValid() {
      return this.text.substring(0,this.reportFor.length) === this.reportFor && this.reportFor.length > 0
    },
    gettingReportValid() {
      return this.text.substring(0,this.gettingReportFor.length) === this.gettingReportFor && this.gettingReportFor.length > 0
    }
  },
  methods: {
    emitNewValue(text) {
      this.$emit('input', text)
    },
    onInputChange(text, oldText){
      this.text = text
      this.emitNewValue(text)
      this.getNewReportWhenNeeded()
    },
    //get a new report, but only when it's needed and when this function
    //hasn't been called for .5 seconds
    getNewReportWhenNeeded() {
      let self = this
      clearTimeout(this.getReportTimeout)
      this.getReportTimeout = setTimeout(function () {
        if(self.text.length >= 3 && !(self.currentReportValid || self.gettingReportValid)) {
          self.getNewReport()
        }
      }, 500)

    },
    setNewValue(option) {
      this.emitNewValue(option.item)
    },
    getNewReport () {
      console.log("Skipping generating unique explorer filter options!")
      return []

      console.log(this.filters)
      if(this.field.length > 0) {
        let query = {
          fields: [this.field],
          stats: [],
          filters: [{ field: this.field, operator: 'CONTAINS', value: this.text }].concat(this.filters),
          startTime: this.startTime || moment().utc().subtract(24, 'hours').valueOf(),
          endTime: this.endTime || moment().utc().valueOf(),
          //arbitrarily high limit
          limit: 10000000
        }
        if(this.reportPromise) {
          this.reportPromise.cancel()
        }
        this.gettingReportFor = this.text
        let reportText = this.text
        this.reportPromise = ReportsApi.bqreport(query, this).then((data) => {
          this.reportPromise = null
          //make sure that another report hasn't been requested in the meantime
          if(this.gettingReportFor === reportText) {
            this.reportFor = reportText
            this.latestReport = data.results
          }
        })
      }
    }
  },
  components: {
    VueAutosuggest
  }
}
</script>



// WEBPACK FOOTER //
// src/reports/components/FilterValueSuggester.vue